/* Privé 2027 – barra de envío gratis y limpieza de filtros */
(function () {
  var cfg = document.getElementById('pv-config');
  if (!cfg) return;
  var umbral = parseInt(cfg.getAttribute('data-umbral'), 10) || 250000; // en centavos
  var ultimoTotal = null;
  var ultimoCarrito = null;

  function plata(c) {
    return '$' + String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function html(total, textoOk) {
    var falta = umbral - total;
    var pct = Math.max(0, Math.min(100, (total / umbral) * 100));
    var msg = falta <= 0 ? textoOk : 'Te faltan <strong>' + plata(falta) + '</strong> para el envío gratis';
    return '<p>' + msg + '</p><div class="pv-envio__barra" aria-hidden="true"><span style="width:' + pct + '%"></span></div>';
  }

  function pintar(el, total, textoOk) {
    if (el.getAttribute('data-total') === String(total)) return;
    el.setAttribute('data-total', String(total));
    el.classList.toggle('pv-envio--ok', total >= umbral);
    el.innerHTML = html(total, textoOk);
  }

  // Ficha de producto: usa el precio del producto
  document.querySelectorAll('[data-pv-envio-precio]').forEach(function (el) {
    var precio = parseInt(el.getAttribute('data-pv-envio-precio'), 10) || 0;
    pintar(el, precio, 'Este producto tiene envío gratis a todo el país');
  });

  // Carrito (cajón lateral y página /cart)
  function asegurarCarrito() {
    if (ultimoTotal === null) return;
    var destinos = [];
    var cab = document.querySelector('cart-drawer .drawer__header');
    if (cab) destinos.push([cab, 'pv-envio--drawer']);
    var pag = document.querySelector('cart-items .title-wrapper-with-link');
    if (pag) destinos.push([pag, 'pv-envio--pagina']);
    destinos.forEach(function (d) {
      var ancla = d[0];
      var el = ancla.nextElementSibling;
      if (!el || !el.classList.contains('pv-envio')) {
        el = document.createElement('div');
        el.className = 'pv-envio ' + d[1];
        el.setAttribute('role', 'status');
        ancla.insertAdjacentElement('afterend', el);
      }
      var vacio = ultimoTotal === 0;
      el.hidden = vacio;
      if (!vacio) pintar(el, ultimoTotal, '¡Listo! Tu envío es gratis');
    });
  }

  function actualizar() {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { ultimoTotal = c.total_price; ultimoCarrito = c; asegurarCarrito(); extrasCarrito(); })
      .catch(function () {});
  }

  // Filtros: oculta las etiquetas internas (tipo de producto y de uso interno)
  var INTERNAS = ['vibrador', 'succionador', 'consolador', 'anal', 'ducha-anal', 'anillo', 'masturbador', 'bdsm', 'arnes', 'bolas-kegel', 'bomba-vacio', 'electroestimulacion', 'kit', 'tarjeta-regalo', 'destacado', 'giftcard', 'priveuy'];
  function limpiarFiltros() {
    document.querySelectorAll('input[type="checkbox"][name="filter.p.tag"]').forEach(function (inp) {
      var item = inp.closest('li') || inp.closest('label');
      if (!item || item.hasAttribute('data-pv-ok')) return;
      item.setAttribute('data-pv-ok', '');
      var etiqueta = (inp.value || '').trim().toLowerCase();
      if (INTERNAS.indexOf(etiqueta) !== -1 && !inp.checked) item.style.display = 'none';
    });
  }

  // Ficha de producto: al cambiar de variante (ej. monto de la tarjeta de regalo) se actualiza al instante
  function precioFicha(precio, sectionId) {
    document.querySelectorAll('[data-pv-envio-precio]').forEach(function (el) {
      el.setAttribute('data-pv-envio-precio', precio);
      pintar(el, precio, 'Este producto tiene envío gratis a todo el país');
    });
  }
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
      var v = e && e.data && e.data.variant;
      if (v && typeof v.price === 'number') precioFicha(v.price, e.data.sectionId);
    });
  }
  // Respaldo: si cambia el id de variante del formulario, buscar el precio en el JSON de variantes
  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('product-info, variant-selects, form[action*="/cart/add"]');
    if (!form) return;
    setTimeout(function () {
      var inp = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      var json = document.querySelector('variant-selects script[type="application/json"], [data-selected-variant]');
      if (!inp || !json) return;
      try {
        var data = JSON.parse(json.textContent);
        var lista = Array.isArray(data) ? data : [data];
        var v = lista.find(function (x) { return String(x.id) === String(inp.value); });
        if (v && typeof v.price === 'number') precioFicha(v.price);
      } catch (err) {}
    }, 350);
  });


  // ===== Extras del carrito: línea de envío, confianza y sugerencias para llegar al envío gratis =====
  var CANDADO = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>';
  var sugeridos = null, pidiendoSug = false;
  function cargarSugeridos(cb) {
    if (sugeridos) return cb(sugeridos);
    if (pidiendoSug) return;
    pidiendoSug = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'collections/complementos/products.json?limit=40')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        sugeridos = (d.products || []).map(function (p) {
          var v = (p.variants || []).find(function (x) { return x.available; });
          if (!v) return null;
          return { id: v.id, titulo: p.title, precio: Math.round(parseFloat(v.price) * 100), img: p.images && p.images[0] ? p.images[0].src : '', url: '/products/' + p.handle };
        }).filter(Boolean);
        cb(sugeridos);
      })
      .catch(function () {});
  }
  function elegirSugeridos(lista, faltan, enCarrito) {
    var libres = lista.filter(function (s) { return enCarrito.indexOf(s.id) === -1; });
    var alcanzan = libres.filter(function (s) { return s.precio >= faltan; }).sort(function (a, b) { return a.precio - b.precio; });
    var resto = libres.filter(function (s) { return s.precio < faltan; }).sort(function (a, b) { return b.precio - a.precio; });
    return alcanzan.concat(resto).slice(0, 2);
  }
  function miniatura(src) { return src ? src.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : ''; }
  function extrasCarrito() {
    if (!ultimoCarrito) return;
    var total = ultimoCarrito.total_price, gratis = total >= umbral;
    // línea de envío y confianza (cajón y página)
    [['cart-drawer .totals', '#CartDrawer-Checkout'], ['#main-cart-footer .totals', '#checkout']].forEach(function (par) {
      var tot = document.querySelector(par[0]);
      if (tot && !(tot.nextElementSibling && tot.nextElementSibling.classList.contains('pv-envio-linea'))) {
        var p = document.createElement('p'); p.className = 'pv-envio-linea'; tot.insertAdjacentElement('afterend', p);
      }
      var linea = tot && tot.nextElementSibling;
      if (linea && linea.classList.contains('pv-envio-linea')) {
        var html = gratis ? 'Envío: <strong>Gratis</strong>' : 'Envío: Montevideo $200 · Interior $240';
        if (linea.getAttribute('data-gratis') !== String(gratis)) { linea.setAttribute('data-gratis', String(gratis)); linea.innerHTML = html; }
      }
      var co = document.querySelector(par[1]);
      if (co && !(co.nextElementSibling && co.nextElementSibling.classList.contains('pv-pago-seguro'))) {
        var q = document.createElement('p'); q.className = 'pv-pago-seguro'; q.innerHTML = CANDADO + 'Pago seguro con Mercado Pago · Paquete discreto';
        co.insertAdjacentElement('afterend', q);
      }
    });
    // sugerencias
    var destinos = [];
    var pie = document.querySelector('cart-drawer .drawer__footer');
    if (pie) destinos.push(pie);
    var piePag = document.getElementById('main-cart-footer');
    if (piePag) destinos.push(piePag);
    destinos.forEach(function (ancla) {
      var caja = ancla.previousElementSibling && ancla.previousElementSibling.classList.contains('pv-sugerencias') ? ancla.previousElementSibling : null;
      if (total === 0 || gratis) { if (caja) caja.remove(); return; }
      if (!caja) { caja = document.createElement('div'); caja.className = 'pv-sugerencias'; ancla.insertAdjacentElement('beforebegin', caja); }
      var faltan = umbral - total;
      if (caja.getAttribute('data-faltan') === String(faltan)) return;
      caja.setAttribute('data-faltan', String(faltan));
      cargarSugeridos(function (lista) {
        var enCarrito = (ultimoCarrito.items || []).map(function (i) { return i.variant_id; });
        var elegidos = elegirSugeridos(lista, faltan, enCarrito);
        if (!elegidos.length) { caja.remove(); return; }
        caja.innerHTML = '<p class="pv-sugerencias__titulo">Sumá algo más y llegá al envío gratis</p>' + elegidos.map(function (s) {
          return '<div class="pv-completa__item"><a class="pv-completa__foto" href="' + s.url + '" tabindex="-1" aria-hidden="true">' + (s.img ? '<img src="' + miniatura(s.img) + '" alt="" loading="lazy" width="80" height="80">' : '') + '</a>' +
            '<div class="pv-completa__info"><a href="' + s.url + '">' + s.titulo.replace(/</g, '&lt;').slice(0, 46) + '</a><span>' + plata(s.precio) + '</span></div>' +
            '<button type="button" class="pv-completa__btn" data-pv-agregar-rapido="' + s.id + '">+ Agregar</button></div>';
        }).join('');
      });
    });
  }

  // ===== Botones "+ Agregar" rápidos (ficha y carrito) =====
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pv-agregar-rapido]');
    if (!b) return;
    e.preventDefault();
    var id = Number(b.getAttribute('data-pv-agregar-rapido'));
    var txt = b.textContent; b.disabled = true; b.textContent = 'Agregando…';
    var drawer = document.querySelector('cart-drawer');
    var datos = { items: [{ id: id, quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      datos.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      datos.sections_url = window.location.pathname;
    }
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(datos)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { b.textContent = 'Sin stock'; return; }
        if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
        if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pv-agregar-rapido', cartData: res });
        b.textContent = '✓ Agregado';
        setTimeout(function () { b.textContent = txt; b.disabled = false; }, 1600);
      })
      .catch(function () { b.textContent = txt; b.disabled = false; });
  });

  actualizar();
  limpiarFiltros();
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(actualizar, 50); });
  }
  var espera;
  new MutationObserver(function () {
    clearTimeout(espera);
    espera = setTimeout(function () { asegurarCarrito(); extrasCarrito(); limpiarFiltros(); }, 60);
  }).observe(document.body, { childList: true, subtree: true });
})();

/* ===== Privé 2027: oferta antes de pagar ===== */
(function () {
  var PREFERIDO = 'prower-ring-anillo-para-pene-desmontable-en-tres-medidas';
  var CLAVE = 'pv_oferta_vista';
  var MAX = 80000; // centavos: solo productos de hasta $800
  var yendo = false;

  function yaVista() { try { return sessionStorage.getItem(CLAVE) === '1'; } catch (e) { return false; } }
  function marcar() { try { sessionStorage.setItem(CLAVE, '1'); } catch (e) {} }
  function plata(c) { return '$' + Math.round(c / 100).toLocaleString('es-UY'); }
  function irAPagar() { yendo = true; window.location.href = (window.routes && window.routes.cart_url ? '/checkout' : '/checkout'); }

  function elegir(carrito) {
    var enCarrito = {};
    (carrito.items || []).forEach(function (i) { enCarrito[i.handle] = true; });
    function apto(p) {
      if (!p || enCarrito[p.handle]) return null;
      var v = (p.variants || []).filter(function (x) { return x.available; })[0];
      if (!v) return null;
      var precio = typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price;
      if (precio > MAX) return null;
      var img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
      if (img && typeof img === 'object') img = img.src;
      return { titulo: p.title, url: '/products/' + p.handle, variante: v.id, precio: precio, img: img };
    }
    return fetch('/products/' + PREFERIDO + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
      .then(function (p) {
        var o = apto(p);
        if (o) return o;
        return fetch('/collections/complementos/products.json?limit=40').then(function (r) { return r.json(); }).then(function (d) {
          var lista = (d.products || []).map(apto).filter(Boolean).sort(function (a, b) { return a.precio - b.precio; });
          return lista[0] || null;
        }).catch(function () { return null; });
      });
  }

  function cerrar(m) { if (m && m.parentNode) m.parentNode.removeChild(m); document.documentElement.classList.remove('pv-oferta-abierta'); }

  function mostrar(o) {
    var m = document.createElement('div');
    m.className = 'pv-oferta';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-labelledby', 'pv-oferta-titulo');
    var img = o.img ? '<img src="' + o.img + (o.img.indexOf('?') > -1 ? '&' : '?') + 'width=300" alt="" width="120" height="120">' : '';
    m.innerHTML =
      '<div class="pv-oferta__caja">' +
        '<button type="button" class="pv-oferta__x" aria-label="Cerrar">&times;</button>' +
        '<p class="pv-oferta__eyebrow">Antes de pagar</p>' +
        '<h2 class="pv-oferta__titulo" id="pv-oferta-titulo">¿Lo sumás a tu pedido?</h2>' +
        '<div class="pv-oferta__prod">' + img +
          '<div><p class="pv-oferta__nombre"></p><p class="pv-oferta__precio">' + plata(o.precio) + '</p>' +
          '<p class="pv-oferta__nota">Va en el mismo paquete discreto, sin costo de envío extra.</p></div>' +
        '</div>' +
        '<button type="button" class="pv-oferta__si">Agregar y pagar</button>' +
        '<button type="button" class="pv-oferta__no">No, gracias, ir a pagar</button>' +
      '</div>';
    m.querySelector('.pv-oferta__nombre').textContent = o.titulo;
    document.body.appendChild(m);
    document.documentElement.classList.add('pv-oferta-abierta');
    var si = m.querySelector('.pv-oferta__si');
    si.focus();
    m.querySelector('.pv-oferta__no').addEventListener('click', function () { irAPagar(); });
    m.querySelector('.pv-oferta__x').addEventListener('click', function () { cerrar(m); });
    m.addEventListener('click', function (e) { if (e.target === m) cerrar(m); });
    document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { cerrar(m); document.removeEventListener('keydown', esc); } });
    si.addEventListener('click', function () {
      si.disabled = true; si.textContent = 'Agregando…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: o.variante, quantity: 1 }] }) })
        .then(function () { irAPagar(); })
        .catch(function () { irAPagar(); });
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="checkout"], #CartDrawer-Checkout, #checkout');
    if (!b || yendo || yaVista()) return;
    e.preventDefault();
    e.stopPropagation();
    marcar();
    b.setAttribute('aria-busy', 'true');
    fetch('/cart.js').then(function (r) { return r.json(); }).then(elegir).then(function (o) {
      b.removeAttribute('aria-busy');
      if (o) mostrar(o); else irAPagar();
    }).catch(function () { b.removeAttribute('aria-busy'); irAPagar(); });
  }, true);
})();
